import { cn } from '@workspace/lib';
import { Typography } from '@workspace/ui/common';

interface ProductSummaryHeadingProps {
  text: string;
  headingFontClass: string;
  className?: string;
}

export function ProductSummaryHeading({ text, headingFontClass, className }: ProductSummaryHeadingProps) {
  return (
    <Typography
      variant="h2"
      className={cn(
        headingFontClass,
        'product-summary-heading order-3 md:order-1 tracking-tight font-heading md:mt-0 text-left w-full md:max-w-131.25',
        className,
      )}
    >
      {text}
    </Typography>
  );
}
